export enum DiskCapacity {
  'MB' = 'MB',
  'GB' = 'GB',
  'TB' = 'TB'
}

export type RestorePartitionItem = unknown & { targetSize: string | number; uiDiskLimit: number };

export interface PartitionsStepValue {
  restoreConfigs?: { [key: string]: any };
  selectedPartitionsFromRDC?: string[];
  restorePartitions: any[];
  restoreParentPartitions?: any[];
  convertToMBR: boolean;
  bootMode?: string;
  valid: boolean;
}

export enum PartitionsBootModeEnum {
  'Default' = '',
  'UEFI' = 'uefi',
  'BIOS' = 'legacy-bios'
}
